import React, { useEffect, useState } from "react";
import { components } from "react-select";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { useLocation } from "react-router-dom";
import getEmployeeTypes from "../../services/getEmployeeTypes";
import getDepartmentServices from "../../services/getDepartments";
import getLocationServices from "../../services/getLocationServices";
import getEmployeeStatusServices from "../../services/getEmployeeStatusServices";
import getWorkingDayTypeServices from "../../services/getWorkingDayTypeServices";
import getLeavePolicyServices from "../../services/getLeavePolicyServices";
import getHolidayCalenderServices from "../../services/getHolidayCalenderServices";
import CountryPhoneCodeService from "../../services/countryPhoneCodeService";
import getLeaveApprovals from "../../services/getLeaveApproval";
import { getOrgId, HEADERS, UpdatOneUser, GetUser, getDepId } from "../api";
import createUserAccounts from "../../services/CreateUserAccount";
import getRoles from "../../services/getRole";

let firstFormValues = {};
let secondFormValues = {};
let thirdFormValues = {};

const options2 = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
];

const DropdownIndicatorSize = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <div style={{ position: "relative" }}>
          <components.DropdownIndicator {...props} />
        </div>
      </components.DropdownIndicator>
    )
  );
};
const customComponentsSize = {
  DropdownIndicator: DropdownIndicatorSize,
};
export default function UpdateUser() {
  const [step, setStep] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const fetchUserData = async (userId) => {
    const orgID = getOrgId();
    const DepId = getDepId();
    try {
      const requestData = { org_id: orgID, user_id: userId, dept_id: DepId };
      const response = await axios.post(GetUser, requestData, {
        headers: HEADERS,
      });
    } catch (error) {
      console.error("An error occurred while fetching user data:", error);
      return null;
    }
  };

  useEffect(() => {
    if (selectedUser) {
    }
  }, [selectedUser]);

  const nextStep = () => {
    setStep(step + 1);
  };
  const prevStep = () => {
    setStep(step - 1);
  };

  const renderForm = () => {
    switch (step) {
      case 1:
        return <QuickInfoForm nextStep={nextStep} />;
      case 2:
        return <PersonalInfoForm nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <OfficialInfoForm nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <DatesForm prevStep={prevStep} />;
      default:
        return null;
    }
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link className="previou-link text-decoration-none" to="/users">
            Employee List
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">
            Update Employee
          </span>
        </span>
      </div>
      <div className="pb-3 d-flex justify-content-between">
        <span className="title">Update Employee</span>
        <input
          id="file-upload"
          type="file"
          accept=".xls, .xlsx"
          style={{ display: "none" }}
        />
      </div>
      {renderForm()}
    </div>
  );
}

// Quick Info Form Component
const QuickInfoForm = ({ nextStep }) => {
  const navigate = useNavigate();

  const [usersRole, setUsersRole] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    user_role_name: "",
    users_role: "",
  });
  useEffect(() => {
    if (formValues.users_role) {
      const matchedRole = usersRole.find(
        (role) => role.role_id === formValues.users_role
      );
      console.log(
        "Prefilled role_name:",
        matchedRole?.role_name || "Not found"
      );
    }
  }, [formValues.users_role, usersRole]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const user_id = searchParams.get("user_id");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const getParamOrNull = (param) => {
      const value = urlParams.get(param);
      return value && value.trim() !== "" ? value : null;
    };

    setFormValues({
      first_name: getParamOrNull("first_name"),
      last_name: getParamOrNull("last_name"),
      email: getParamOrNull("email"),
      // user_role_name: getParamOrNull("user_role_name"),
      users_role: getParamOrNull("user_role_id"),
    });

    setIsDisabled(getParamOrNull("is_disabled") === "true");
  }, []);

  const handleNext = () => {
    nextStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      // user_role_name: "",
      users_role: "",
    },
  });

  const onSubmitFirstForm = async (data) => {
    const isValid = await trigger([
      "first_name",
      "last_name",
      "email",
      "users_role",
    ]);
    if (isValid) {
      setFormValues({ ...formValues, ...data });
      firstFormValues = formValues;
      handleNext();
    }
  };

  useEffect(() => {
    const companySize = async () => {
      const response = await getRoles();

      if (response.response_code === "0000") {
        setUsersRole(response.data);
      } else {
        setUsersRole([{ role_id: "", role_name: "" }]);
      }
    };
    companySize();
  }, []);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitFirstForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title ">Quick Information</h5>
          </div>

          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group">
                  <label>First name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your first name"
                    value={formValues.first_name}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        first_name: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>
                <div className="form-group">
                  <label>Last name</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your last name"
                    value={formValues.last_name}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        last_name: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>
                <div className="form-group">
                  <label>Email address</label>
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Enter your email"
                    value={formValues.email}
                    onChange={(e) =>
                      setFormValues({ ...formValues, email: e.target.value })
                    }
                  />
                  <span className="warning"></span>
                </div>
              </div>

              <div className="col-md-6 pl-3">
                <div className="form-group">
                  <label htmlFor="">User Role</label>
                  <select
                    className="form-select"
                    {...register("users_role")}
                    value={formValues.users_role}
                    disabled={
                      usersRole.find(
                        (role) => role.role_id === formValues.users_role
                      )?.role_name === "Root User"
                    }
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setFormValues({
                        ...formValues,
                        users_role: selectedValue,
                      });
                    }}
                  >
                    <option value="" disabled>
                      Select user role
                    </option>

                    {(() => {
                      const selectedRole = usersRole.find(
                        (role) => role.role_id === formValues.users_role
                      );
                      const selectedRoleName = selectedRole?.role_name;

                      let filteredRoles = usersRole;

                      if (
                        selectedRoleName === "Admin" ||
                        selectedRoleName === "User"
                      ) {
                        filteredRoles = usersRole.filter((role) =>
                          ["Admin", "User"].includes(role.role_name)
                        );
                      } else if (selectedRoleName === "Root User") {
                        filteredRoles = usersRole.filter(
                          (role) => role.role_name === "Root User"
                        );
                      }

                      return filteredRoles.map((option, index) => (
                        <option key={index} value={option.role_id}>
                          {option.role_name}
                        </option>
                      ));
                    })()}
                  </select>

                  {errors.users_role && (
                    <span className="warning">{errors.users_role.message}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button
            className="button"
            style={{ background: "#2d7d9f", color: "#fff" }}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};
const PersonalInfoForm = ({ nextStep, prevStep }) => {
  const [employeeType, setEmployeeType] = useState([]);
  const [department, setDepartment] = useState([]);
  const [userLocation, setUserLocation] = useState([]);
  const [employeeStatus, setEmployeeStatus] = useState([]);
  const [leaveApprovalBy, setLeaveApprovalBy] = useState([]);
  const [leavePolicy, setLeavePolicy] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [holidayType, setHolidayType] = useState([
    { holiday_calendar_id: "", calendar_name: "" },
  ]);
  const [formValues, setFormValues] = useState({
    employee_code: "",
    job_title: "",
    employee_type_name: "",
    department_name: "",
    department: "",
    user_location: "",
    location_name: "",
    employee_status_name: "",
    employee_status: "",
    leave_policy_name: "",
    leave_policy: "",
    holiday_type_name: "",
    holiday_type: "",
    leave_approved_by: null, // Initialized as null for integer field
    is_head: false,
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const user_id = searchParams.get("user_id");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const EmployeeCode = urlParams.get("employee_code") || "";
    const JobTittle = urlParams.get("job_title") || "";
    const EmployeeType = urlParams.get("employee_type_name") || "";
    const EmployeeTypeid = urlParams.get("employee_type") || "";
    const Department = urlParams.get("department_name") || "";
    const departmentId = urlParams.get("department") || "";
    const Location = urlParams.get("location_name") || "";
    const Locationid = urlParams.get("user_location") || "";
    const EmployeeStatus = urlParams.get("employee_status_name") || "";
    const EmployeeStatusid = urlParams.get("employee_status") || "";
    const LeavePolicy = urlParams.get("leave_policy_name") || "";
    const LeavePolicyid = urlParams.get("leave_policy") || "";
    const HolidayType = urlParams.get("holiday_type_name") || "";
    const HolidayTypeid = urlParams.get("holiday_type") || "";
    const LeaveApproveBy = urlParams.get("leave_approved_by") || "";
    const isHead = urlParams.get("is_head") || "";
    setFormValues({
      employee_code: EmployeeCode,
      job_title: JobTittle,
      // employee_type_name: EmployeeType,
      employee_type: EmployeeTypeid,
      // department_name: Department,
      department: departmentId,
      // location_name: Location,
      user_location: Locationid,
      // employee_status_name: EmployeeStatus,
      employee_status: EmployeeStatusid,
      // leave_policy_name: LeavePolicy,
      leave_policy: LeavePolicyid,
      // holiday_type_name: HolidayType,
      holiday_type: HolidayTypeid,
      leave_approved_by:
        LeaveApproveBy === "" || LeaveApproveBy === "null"
          ? null
          : parseInt(LeaveApproveBy, 10),
      is_head: isHead === "true",
    });

    setIsDisabled(urlParams.get("is_disabled") === "true");
  }, []);
  useEffect(() => {
    const employeeTypes = async () => {
      const response = await getEmployeeTypes();
      if (response.response_code === "0000") {
        setEmployeeType(response.data);
      } else {
        setEmployeeType([
          {
            employee_type_id: "",
            employee_type_name: "",
          },
        ]);
      }
    };
    employeeTypes();
    const employeeManagers = async () => {};
    employeeManagers();

    const departments = async () => {
      const response = await getDepartmentServices();
      if (response.response_code === "0000") {
        setDepartment(response.data);
      } else {
        setDepartment([{ dept_id: "", dept_name: "" }]);
      }
    };
    departments();

    const userLocations = async () => {
      const response = await getLocationServices();
      if (response.response_code === "0000") {
        console.log("Locations>>>>>>>>>>>>", response);
        setUserLocation(response.data);
      } else {
        setUserLocation([{ location_id: "", location_name: "" }]);
      }
    };
    userLocations();

    const employStatus = async () => {
      const response = await getEmployeeStatusServices();
      if (response.response_code === "0000") {
        setEmployeeStatus(response.data);
      } else {
        setEmployeeStatus([
          { employee_status_id: "", employee_status_name: "" },
        ]);
      }
    };
    employStatus();
    const leavePolicies = async () => {
      const response = await getLeavePolicyServices();
      if (response.response_code === "0000") {
        console.log("leavePolicies>>>>>>>>>>>>", response);
        setLeavePolicy(response.data);
      } else {
        setLeavePolicy([
          {
            leave_policy_id: "",
            leave_policy_name: "",
          },
        ]);
      }
    };
    leavePolicies();
    const holidayTypes = async () => {
      const response = await getHolidayCalenderServices();
      console.log("getHolidayCalenderServices=======", response);
      if (response.response_code === "0000") {
        setHolidayType(response.data);
      } else {
        setHolidayType([{ holiday_calendar_id: "", calendar_name: "" }]);
      }
    };
    holidayTypes();
    const leaveApprovalBy = async () => {
      const response = await getLeaveApprovals();
      if (response.response_code === "0000") {
        setLeaveApprovalBy(response.data);
      } else {
        setLeaveApprovalBy([{ approvals_id: "", approvals_name: "" }]);
      }
    };
    leaveApprovalBy();
  }, []);

  const handleNext = () => {
    nextStep();
  };

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      employee_code: "",
      job_title: "",
      employee_type_name: "",
      department_name: "",
      department: "",
      user_location: "",
      location_name: "",
      employee_status_name: "",
      employee_status: "",
      leave_policy_name: "",
      leave_policy: "",
      holiday_type_name: "",
      holiday_type: "",
      leave_approved_by: null, // Initialized as null for integer field
      is_head: false,
    },
  });

  const onSubmitSecondForm = async (data) => {
    const isValid = await trigger([
      "department_name",
      "employee_code",
      "employee_status",
      "leave_approved_by",
      "employee_type",
      "holiday_type_name",
      "holiday_type",
      "is_head",
      "job_title",
      "leave_policy",
      "user_location",
    ]);
    if (isValid) {
      handleNext();
      console.log("onSubmitSecondForm>>>>", data);

      const datas = data;
      datas.is_head =
        datas.is_head === "true"
          ? true
          : datas.is_head === "false"
          ? false
          : false;
      datas.leave_approved_by = +datas.leave_approved_by;
      datas.job_title = +datas.job_title;
      secondFormValues = formValues;
      console.log("secondFormValues>>>???", secondFormValues);
    }
  };
  const isHead = [
    {
      id: true,
      is_heads: "Yes",
    },
    {
      id: false,
      is_heads: "No",
    },
  ];

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitSecondForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title ">Official Information</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group">
                  <label htmlFor="">Department</label>
                  <select
                    className="form-select"
                    {...register("department")}
                    value={formValues.department} // Set the value of the select to the user role
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        department: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select department
                    </option>
                    {department.map((option, index) => (
                      <option key={index} value={option.dept_id}>
                        {option.dept_name}
                      </option>
                    ))}
                  </select>
                  <span className="warning"></span>
                </div>

                <div className="form-group mt-2">
                  <label>Employee code</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your employee code"
                    value={formValues.employee_code}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        employee_code: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>
                <div className="form-group">
                  <label>Job title</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter job title"
                    value={formValues.job_title}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        job_title: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>

                <div className="form-group">
                  <label htmlFor="">Employee Type</label>
                  <select
                    className="form-select"
                    {...register("employee_type")}
                    value={formValues.employee_type}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        employee_type: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select employee type
                    </option>
                    {employeeType.map((option, index) => (
                      <option key={index} value={option.employee_type_id}>
                        {option.employee_type_name}
                      </option>
                    ))}
                  </select>
                  <span className="warning"></span>
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="">Location</label>
                  <select
                    className="form-select"
                    {...register("user_location")}
                    value={formValues.user_location}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        user_location: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select location
                    </option>
                    {userLocation.map((option, index) => (
                      <option key={index} value={option.location_id}>
                        {option.location_name}
                      </option>
                    ))}
                  </select>
                  <span className="warning"></span>
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="">Employee status</label>
                  <select
                    className="form-select"
                    {...register("employee_status")}
                    value={formValues.employee_status}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        employee_status: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select employee status
                    </option>
                    {employeeStatus.map((option, index) => (
                      <option key={index} value={option.employee_status_id}>
                        {option.employee_status_name}
                      </option>
                    ))}
                  </select>
                  <span className="warning"></span>
                </div>
              </div>

              <div className="col-md-6 pl-3">
                <div className="form-group">
                  <div className="form-group">
                    <label htmlFor="">Leave policy</label>
                    <select
                      className="form-select"
                      {...register("leave_policy")}
                      value={formValues.leave_policy}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          leave_policy: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled>
                        Select leave policy
                      </option>
                      {leavePolicy.map((option, index) => (
                        <option key={index} value={option.leave_policy_id}>
                          {option.leave_policy_name}
                        </option>
                      ))}
                    </select>
                    {errors.leave_policy && (
                      <span className="warning">
                        {errors.leave_policy.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="">Holiday type</label>
                  <select
                    className="form-select"
                    {...register("holiday_type")}
                    value={formValues.holiday_type}
                    e
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        holiday_type: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select holiday type
                    </option>
                    {holidayType.map((option, index) => (
                      <option key={index} value={option.holiday_calendar_id}>
                        {option.calendar_name}
                      </option>
                    ))}
                  </select>
                  {errors.holiday_type && (
                    <span className="warning">
                      {errors.holiday_type.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="">Leave Approve By</label>
                  <select
                    className="form-select"
                    {...register("leave_approved_by")}
                    value={formValues.leave_approved_by}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        leave_approved_by: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select who approved the leave
                    </option>
                    {leaveApprovalBy.map((option, index) => (
                      <option key={index} value={option.approvals_id}>
                        {option.approvals_name}
                      </option>
                    ))}
                  </select>
                  <span className="warning"></span>
                </div>

                <div className="form-group">
                  <label htmlFor="">Is Head</label>
                  <select
                    className="form-select"
                    {...register("is_head")}
                    value={formValues.is_head}
                    onChange={(e) =>
                      setFormValues({ ...formValues, is_head: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Select isHead
                    </option>
                    {isHead.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.is_heads}
                      </option>
                    ))}
                  </select>
                  {errors.is_head && (
                    <span className="warning">{errors.is_head.message}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-previous rounded" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre">Next</button>
        </div>
      </form>
    </div>
  );
};

const OfficialInfoForm = ({ nextStep, prevStep }) => {
  const [countryPhoneCode, setCountryPhoneCode] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [formValues, setFormValues] = useState({
    address_1: "",
    address_2: "",
    user_state: "",
    city: "",
    zip_code: "",
    country: "",
    gender: "",
    country_code: "",
    phone_no: "",
    user_id: null,
  });
  const gender = [
    {
      id: "Male",
      gender: "Male",
    },
    {
      id: "Female",
      gender: "Female",
    },
    {
      id: "Others",
      gender: "Others",
    },
  ];

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const user_id = searchParams.get("user_id");
  formValues.user_id = user_id;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const Address1 = urlParams.get("address_1") || "";
    const Address2 = urlParams.get("address_2") || "";
    const State = urlParams.get("user_state") || "";
    const CityName = urlParams.get("city") || "";
    const ZipCode = urlParams.get("zip_code") || "";
    const Country = urlParams.get("country") || "";
    const Gender = urlParams.get("gender") || "";
    const CountryCode = urlParams.get("country_code") || "";
    const PhoneNo = urlParams.get("phone_no") || "";

    setFormValues({
      address_1: Address1,
      address_2: Address2,
      user_state: State,
      city: CityName,
      zip_code: ZipCode,
      country: Country,
      gender: Gender,
      country_code: CountryCode,
      phone_no: PhoneNo,
    });
    setIsDisabled(urlParams.get("is_disabled") === "true");
  }, []);

  const handleNext = () => {
    nextStep();
  };

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    defaultValues: {
      address_1: "",
      address_2: "",
      user_state: "",
      city: "",
      zip_code: "",
      country: "",
      gender: "",
      country_code: "",
      phone_no: "",
    },
  });

  const onSubmitThirdForm = async (data) => {
    const isValid = await trigger([
      "address_1",
      "address_2",
      "city",
      "country",
      "gender",
      "phone_no",
      "user_state",
      "zip_code",
      "country_code",
    ]);
    if (isValid) {
      handleNext();

      thirdFormValues = formValues;
      console.log("ThirdForm Data", thirdFormValues);
    }
  };
  useEffect(() => {
    const getCountriesPhoneCode = async () => {
      const response = await CountryPhoneCodeService();
      if (response.response_code === "0000") {
        setCountryPhoneCode(response.data);
      } else {
        setCountryPhoneCode([{ country_code: "", country_name: "" }]);
      }
    };
    getCountriesPhoneCode();
  });
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitThirdForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex  p-2 ">
            <h5 className="title ">Personal Information</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 ">
                <div className="form-group">
                  <label htmlFor="">Country</label>
                  <select
                    className="form-select"
                    {...register("country")}
                    value={formValues.country}
                    onChange={(e) =>
                      setFormValues({ ...formValues, country: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Select Country
                    </option>
                    {countryPhoneCode.map((option, index) => (
                      <option key={index} value={option.country_name}>
                        {option.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="warning">{errors.country.message}</span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label>Dzongkhag</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter address 1"
                    value={formValues.address_1}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        address_1: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>

                <div className="form-group">
                  <label>Present Address</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter address 2"
                    value={formValues.address_2}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        address_2: e.target.value,
                      })
                    }
                  />
                  <span className="warning"></span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="">Gender</label>
                  <select
                    className="form-control"
                    {...register("gender")}
                    value={formValues.gender}
                    onChange={(e) =>
                      setFormValues({ ...formValues, gender: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Select gender
                    </option>
                    {gender.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.gender}
                      </option>
                    ))}
                  </select>
                  {errors.gender && (
                    <span className="warning">{errors.gender.message}</span>
                  )}
                </div>
                <div className="row d-flex flex-row">
                  <div className="col-md-12">
                    <div className="form-group mt-2">
                      <label>Country Code</label>
                      <select
                        className="form-select"
                        {...register("country_code")}
                        value={formValues.country_code}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            country_code: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select country code
                        </option>
                        {countryPhoneCode.map((option, index) => (
                          <option key={index} value={option.country_code}>
                            {option.country_code}
                          </option>
                        ))}
                      </select>
                      {errors.country_code && (
                        <span className="warning">
                          {errors.country_code.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group  mt-2">
                      <label>Phone Number</label>
                      <input
                        type="text"
                        placeholder="Enter phone number"
                        value={formValues.phone_no}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            phone_no: e.target.value,
                          })
                        }
                      />
                      {errors.phone_no && (
                        <span className="warning">
                          {errors.phone_no.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-previous rounded" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre">Next</button>
        </div>
      </form>
    </div>
  );
};

const DatesForm = ({ prevStep }) => {
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [formValues, setFormValues] = useState({
    dob: "",
    hire_date: "",
    separation_date: "",
  });

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm({
    defaultValues: {
      dob: "",
      hire_date: "",
      separation_date: "",
    },
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const user_id = searchParams.get("user_id");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const HireDate = urlParams.get("hire_date") || "";
    const SeperationDate = urlParams.get("separation_date") || "";
    const DOB = urlParams.get("dob") || "";
    setFormValues({
      dob: DOB,
      hire_date: HireDate,
      separation_date: SeperationDate,
    });
    setIsDisabled(urlParams.get("is_disabled") === "true");
  }, []);

  const onSubmitFourthForm = async (data) => {
    const isValid = await trigger(["dob", "hire_date", "separation_date"]);
    if (isValid) {
      const combinedData = {
        ...firstFormValues,
        ...secondFormValues,
        ...thirdFormValues,
        ...formValues,
      };
    }
  };

  const handleUpdate = async () => {
    function normalizeValues(obj) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (value === "" || value === "null") {
            return [key, null];
          }
          return [key, value];
        })
      );
    }

    const combinedData = {
      ...normalizeValues(firstFormValues),
      ...normalizeValues(secondFormValues),
      ...normalizeValues(thirdFormValues),
      ...normalizeValues(formValues),
    };

    console.log("🧾 Combined Data (normalized):", combinedData);

    console.table("asdf", combinedData); // Logs it as a neat table
    // console.log((combinedData, null, 2)); // Pretty JSON format

    const cleanedData = Object.fromEntries(
      Object.entries(combinedData).filter(
        ([_, v]) => v !== null && v !== "null" && v !== ""
      )
    );
    Object.entries(combinedData).forEach(([key, value]) => {
      if (value === null || value === "null") {
        console.warn(`${key} is null`);
      }
    });

    Swal.fire({
      title: "Are you sure?",
      text: "You are about to cancel the update",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Update",
      cancelButtonColor: "blue",
      confirmButtonText: "Cancel",
      confirmButtonColor: "grey",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        try {
          const response = await axios.post(UpdatOneUser, cleanedData, {
            headers: HEADERS,
          });
          console.log("res", response);
          console.log("cleanData", cleanedData);
          if (response.data.response_code === "0000") {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: response.data.response_description,
            });
            navigate("/users/");
            window.location.reload();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: response.data.response_description,
            });
          }
        } catch (error) {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Something went wrong while updating user.",
          });
        }
      }
    });
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitFourthForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title ">Dates</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="">
                  <label>Hire Date</label>
                  <input
                    className="form-control"
                    type="date"
                    value={formValues.hire_date}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        hire_date: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-2">
                  <label>Sepration Date</label>
                  <input
                    className="form-select"
                    type="date"
                    value={formValues.separation_date}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        separation_date: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-2">
                  <label>Date Of Birth</label>
                  <input
                    className="form-select"
                    type="date"
                    value={formValues.dob}
                    onChange={(e) =>
                      setFormValues({ ...formValues, dob: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-previous rounded" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </form>
    </div>
  );
};
